export default {"src":"/_next/static/media/agricultural-land-icon.41071166.svg","height":87,"width":108,"blurWidth":0,"blurHeight":0};